export enum ROLES {
  PANEL = 'lui-accordion-panel',
  ITEM = 'lui-accordion-item',
}
export const COMPONENT_NAMESPACE = 'lui-accordion-group';
